import Params               from "dashboard/dist/Core/Params";
import { setSection }       from "Actions/Core/CoreActions";
import { GuideQuestion }    from "Utils/API";

// Types
import {
    GUIDE_QUESTION, GUIDE_QUESTION_LOADING,
    GUIDE_QUESTION_LIST, GUIDE_QUESTION_ELEM, GUIDE_QUESTION_CREATE,
} from "Utils/Types";



/**
 * Fetches the Question List
 * @param {String=} type
 * @param {Number=} elemID
 * @param {Object=} params
 * @returns {(dispatch) => Void}
 */
export function fetchQuestions(type = "", elemID = 0, params = {}) {
    return async (dispatch) => {
        dispatch({ type : GUIDE_QUESTION_LOADING });
        Params.unset(params);
        let data = {};

        switch (type) {
        case "GUIDE":
            params.guideID = elemID;
            data = await GuideQuestion.getAllForGuide(params);
            break;
        default:
        }
        data.sort = params;
        dispatch({ type : GUIDE_QUESTION_LIST, data });
        dispatch(setSection(GUIDE_QUESTION));
    };
}

/**
 * Fetches a single Question
 * @param {Number} questionID
 * @returns {(dispatch) => Void}
 */
export function fetchQuestion(questionID) {
    return async (dispatch) => {
        const data = await GuideQuestion.getOne({ questionID });
        dispatch({ type : GUIDE_QUESTION_ELEM, data });
    };
}

/**
 * Fetches the Question Create data
 * @param {Number} guideID
 * @returns {(dispatch: Function) => Void}
 */
export function fetchQuestionCreate(guideID) {
    return async (dispatch) => {
        const data = await GuideQuestion.getCreateData({ guideID });
        dispatch({ type : GUIDE_QUESTION_CREATE, data });
    };
}



/**
 * Edits/Creates a Question
 * @param {Object} data
 * @returns {() => Void}
 */
export function editQuestion(data) {
    return () => GuideQuestion.edit(data);
}

/**
 * Deletes a Question
 * @param {Number} questionID
 * @returns {() => Void}
 */
export function deleteQuestion(questionID) {
    return () => GuideQuestion.delete({ questionID });
}
